import { makeVar } from "@apollo/client";

// Moment when the last thread was read.
export const lastThreadReadTimestampVar = makeVar<number | null>(null);
